import { standardApiHandler } from "../../../core/core-api/apiTools";
import { geoCalculationsAdapter } from "./geoCalculations.adapter";
import GeoCalculationItem from "../../../geocalc/dto/GeoCalculationItem";

export type GeoCalculationsServiceParams = {};
export type GeoCalculationsServiceResponse = [
    {
        calculationId: number;
        calculationName: string;
        geometry: string;
    }
];

export type GeoCalculationsService = ({}) => Promise<GeoCalculationItem[]>;
export const geoCalculationsService: GeoCalculationsService = standardApiHandler(geoCalculationsAdapter);
